/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type SellerDirectoryLayout_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SellerDirectoryContentModule_viewer" | "SellersContainer_viewer">;
    readonly " $refType": "SellerDirectoryLayout_viewer";
};
export type SellerDirectoryLayout_viewer$data = SellerDirectoryLayout_viewer;
export type SellerDirectoryLayout_viewer$key = {
    readonly " $data"?: SellerDirectoryLayout_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SellerDirectoryLayout_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SellerDirectoryLayout_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SellerDirectoryContentModule_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SellersContainer_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'df9c0011da2cdb27c5d9eb114aa15a14';
export default node;
